import { Link } from '@sitecore-jss/sitecore-jss-nextjs';

import { ClickActionLinkItem } from 'src/types/ClickActionLinkItem';

import styles from 'src/components/account/Login/_Fields/LoginFields.module.css';

export type SupportLinksProps = {
	className?: string;
	links: ClickActionLinkItem[];
	contentChangeLinks?: [
		{
			href: RegExp | string;
			action: () => void;
		}
	];
};

export function SupportLinks(props: SupportLinksProps): JSX.Element {
	if (!props.links) {
		return <></>;
	}

	if (props.contentChangeLinks) {
		props.links.forEach((item) => {
			const href = item.fields.Link?.value?.href;

			props.contentChangeLinks?.forEach((trigger) => {
				item.isTrigger = href?.match(trigger?.href) ? true : false;
				item.clickAction = trigger.action;
			});
		});
	}

	return (
		<ul className={`${styles.supportLinks} ${props.className}`}>
			{props.links.map((item, index) => (
				<li className={styles.supportLinkItem} key={`sharedListItem-${index}`}>
					{item.isTrigger ? (
						<button type="button" className={styles.link} onClick={item.clickAction}>
							{item.fields.Link?.value?.text}
						</button>
					) : (
						item.fields.Link.value?.href && <Link field={item.fields.Link} />
					)}
				</li>
			))}
		</ul>
	);
}
